import { createStore, applyMiddleware, compose } from 'redux'
import { createBrowserHistory } from 'history'
import { routerMiddleware } from 'connected-react-router'
import { TypedUseSelectorHook, useSelector } from 'react-redux'
import createRootReducer from './reducer'
import createSagaMiddleware from 'redux-saga'
import rootsagas from './rootSagas'
// 创建浏览器历史记录
export const history = createBrowserHistory()
// 具有路由器状态的root reducer
const reducer = createRootReducer(history)
// 创建自定义类型useSelector 并导出
type RootState = ReturnType<typeof reducer>
export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector
// 创建中间件
const sagaMiddleware = createSagaMiddleware()
const enhancer = applyMiddleware(routerMiddleware(history), sagaMiddleware)

export default createStore(reducer, compose(enhancer))
// 监听rootsagas文件
sagaMiddleware.run(rootsagas)
import { createStore, applyMiddleware, compose } from 'redux'
import { createBrowserHistory } from 'history'
import { routerMiddleware } from 'connected-react-router'
import { TypedUseSelectorHook, useSelector } from 'react-redux'
import createRootReducer from './reducer'
import createSagaMiddleware from 'redux-saga'
import rootsagas from './rootSagas'
// 创建浏览器历史记录
export const history = createBrowserHistory()
// 具有路由器状态的root reducer
const reducer = createRootReducer(history)
// 创建自定义类型useSelector 并导出
type RootState = ReturnType<typeof reducer>
export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector
// 创建中间件
const sagaMiddleware = createSagaMiddleware()
const enhancer = applyMiddleware(routerMiddleware(history), sagaMiddleware)

export default createStore(reducer, compose(enhancer))
// 监听rootsagas文件
sagaMiddleware.run(rootsagas)
